import React from 'react';
import Navbar from './Nav';

function About() {
    return (
        <section>
            <div className='App'>
            <Navbar />
            <span className="name">Eyal's </span><span className="second_word"> Portfolio</span>
            </div>
        </section>
        
    );
}

export default About;